import React from 'react';
import { connect } from 'dva';
import { Modal, Popover, Button, Spin, Row, Col } from 'antd';
import moment from 'moment';
import request from 'superagent';
import BaseComponent from '../../../components/BaseComponent';
import Dimio, {DimioNotice} from '../../../components/Dimio';
import DimioModal from '../../../components/DimioModal';
//import Slider from 'react-slick';
import NewsItem from './NewsItem';

import LoadAd from './LoadAd';
import config from '../config/config';
import "../style/news.scss"

import S from 'string';
import _ from 'lodash';

const NOI = 3;
const MODAL_KEY = 'detail';

class NewsPage extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedItem: false,
      noi:NOI,
    };

    this.showDetail = this.showDetail.bind(this);
    this.loadMore = this.loadMore.bind(this);
  }

  componentWillMount() {
    const {dispatch, news} = this.props;

//    this.showLoading();
    moment.locale('ja-JP');
//    console.info(news);
//    const query = {id: this.props.business.id};
//    const url = 'https://tora-tora.net/weblog/wp-json/wp/v2/info/';
    const self = this;

    if(news.url) {
      request
        .get(news.url)
        .type('json')
        .then(response => {
          dispatch({
            type: 'news/setNews',
            data: response.body
          });
//          self.hideLoading();
        })
        .catch(err => {
          throw err
        });
    }else{
      throw "URL is not specified";
    }
  }


  showDetail(data){
//    console.info(data);

    this.showModal(MODAL_KEY, data);
    this.gtmEvent("click", "notification", data.id);

    this.setState({
      selectedItem: data,
    });
  }

  loadMore(){
    let   {noi}  = this.state;
    const {news} = this.props;
    const {data} = news;

    if(data){
      noi = noi + 3;
      if(noi > data.length){
        noi = data.length;
      }
    }
    this.setState({noi: noi});
  }

  render() {
    const {noi, selectedItem}  = this.state;
    const {news} = this.props;
    const {data} = news;

    // news items
    const items = [];
    if(data) {
      for (let i = 0; i < noi; i++) {
        items.push(<Col xs={24} md={8} key={i}>
          <NewsItem item={data[i]} index={i} key={i} showDetail={this.showDetail}/></Col>);
      }
    }

    return (
      <section>
        {/*        <DimioNotice {...news} /> */}

        <Row type="flex">
          {items}
        </Row>
        <Row type="flex" justify="center" center="xs">
          <Col xs={24} md={6}>
            <div className="mb-3">
              <Button type="primary" className="btn-block gtm_info-from-wp__loadmore" value="large" onClick={this.loadMore}>次の3件を表示</Button>
            </div>
          </Col>
        </Row>

        <DimioModal
          id={MODAL_KEY}
          appKey={this.props.appKey}
        >
          {selectedItem &&
            <div>
              <div className="modal-desc" dangerouslySetInnerHTML={{__html: selectedItem.desc}}></div>

              {(selectedItem.ad && selectedItem.category) &&
              <div className="ad-area">
                <LoadAd ad={selectedItem.ad} category={selectedItem.category}/>
              </div>
              }
            </div>
          }
        </DimioModal>

      </section>
    );
  }
}

export default connect(({ news }) => ({
  news
}))(NewsPage);



// WEBPACK FOOTER //
// ./src/pages/news/components/NewsPage.js